import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';

function InfoBanner({ icon: Icon = FaInfoCircle, title, children, className = '', style = {} }) {
  return (
    <div
      className={`info-banner ${className}`}
      style={{
        border: '1px solid #D0E3FF',
        background: '#F5FAFF',
        borderRadius: 8,
        padding: 12,
        marginTop: 8,
        marginBottom: 8,
        ...style
      }}
    >
      <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
        <Icon size={16} color="#0A66C2" style={{ marginTop: 2, flexShrink: 0 }} />
        <div style={{ lineHeight: 1.4 }}>
          {title && (
            <div style={{ fontWeight: 600, marginBottom: 4 }}>{title}</div>
          )}
          <div style={{ color: '#344054', fontSize: 13 }}>{children}</div>
        </div>
      </div>
    </div>
  );
}

export default InfoBanner;


